// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"197":"96d386af","622":"695314fd","814":"0f92b82d"}[chunkId] + ".css";
};